import { Dispatch, GetState } from '../../types'
import { isStarred } from './selectors';
import { isUndefined } from 'util';

/**
 *  Action Constants
 */
export const ChangeStarredDashboard = 'Monitoring/Dashboard/ChangeStarredDashboard';

/**
 *  Action Type
 */
export type ChangeStarredDashboardAction = {
  type: 'Monitoring/Dashboard/ChangeStarredDashboard'
  payload: {
    starred: boolean
  }
}

/**
 *  Action Creators
 */

export const changeDashboardStarred = (starred: boolean) => (dispatch: Dispatch, getState: GetState) => {
  if (!isUndefined(starred) && isStarred(getState()) !== starred) {
    dispatch({
      type: ChangeStarredDashboard,
      payload: {starred: starred}
    })
  }
};

export type DashboardActions =
  | ChangeStarredDashboardAction
